import {createApi} from "@reduxjs/toolkit/query/react"
import baseQuery from "../../utils/apiIIKOConfig"
import {IBasicParams, IBasicResponse} from "../../types/api"
import {
    IReviewCategory,
    IReviewCategoryCreateParams,
    IReviewCategoryCreateResponse,
    IReviewCategoryDeleteParams, IReviewCategoryUpdateParams, IReviewCategoryUpdateTagsParams
} from "./ReviewCategoryApiTypes"

export const reviewCategoryApi = createApi({
    reducerPath: "reviewCategoryApi",
    baseQuery,
    tagTypes: ["review-categories"],
    endpoints: build => ({
        getReviewCategories: build.query<IBasicResponse<IReviewCategory[]>, IBasicParams>({
            query: ({lang}) => ({
                method: "GET",
                url: `v1/review-categories/list`,
                headers: {
                    "Accept-Language": lang
                },
            }),
            providesTags: ["review-categories"]
        }),
        createReviewCategory: build.mutation<IBasicResponse<IReviewCategoryCreateResponse>, IReviewCategoryCreateParams>({
            query: ({lang, ...body}) => ({
                method: "POST",
                url: `v1/review-categories`,
                headers: {
                    "Accept-Language": lang,
                },
                body
            }),
            invalidatesTags: ["review-categories"]
        }),
        deleteReviewCategory: build.mutation<IBasicResponse<void>, IReviewCategoryDeleteParams>({
            query: ({lang, id}) => ({
                method: "DELETE",
                url: `v1/review-categories/${id}`,
                headers: {
                    "Accept-Language": lang
                }
            }),
            invalidatesTags: ["review-categories"]
        }),
        updateReviewCategory: build.mutation<IBasicResponse<void>, IReviewCategoryUpdateParams>({
            query: ({lang, id, ...body}) => ({
                method: "PATCH",
                url: `v1/review-categories/${id}`,
                headers: {
                    "Accept-Language": lang,
                },
                body
            }),
            invalidatesTags: ["review-categories"]
        }),
        updateReviewCategoryTag: build.mutation<IBasicResponse<void>, IReviewCategoryUpdateTagsParams>({
            query: ({lang, id, ...body}) => ({
                method: "PATCH",
                url: `v1/review-categories/${id}/tags`,
                headers: {
                    "Accept-Language": lang,
                },
                body
            }),
            invalidatesTags: ["review-categories"]
        })
    })
})

export const {
    useGetReviewCategoriesQuery,
    useCreateReviewCategoryMutation,
    useDeleteReviewCategoryMutation,
    useUpdateReviewCategoryMutation,
    useUpdateReviewCategoryTagMutation
} = reviewCategoryApi
